import API from '@services/API';

const ColaboradorService = {
  filtrar: async (processo, filtros) => await API.filters(`colaboradores`, filtros),
	buscarPorId: async (id) => await API.list(`/colaboradores/${id}`),
  buscarProcessosPorColaborador: async (id) => await API.list(`/colaboradores/${id}/processo`),
  adicionar: async (colaborador) => await API.add(`colaboradores`, colaborador),
  adicionarProcesso: async (colaboradorProcesso) => await API.add(`colaboradores/processo`, colaboradorProcesso),
	editar: async (id, envelope) => await API.edit(`colaboradores`, id, envelope),

  ativar: async (id) => await API.edit(`colaboradores`, id + "/ativar", {}),
  desativar: async (id) => await API.edit(`colaboradores`, id + "/desativar", {}),

	excluir: async (id) => await API.remove(`colaboradores`,id),
  excluirProcesso: async (colaborador,processo) => await API.remove(`colaboradores/processo/${colaborador}`,processo),
}

export default ColaboradorService;
